import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis } from "recharts";

export default function Chart({ data }) {
  // Format the y-axis values (e.g., 200k, 400k)
  const formatYAxis = (value) => {
    if (value === 0) return "0";
    return `${value / 1000}k`;
  };

  return (
    <div className="h-[300px] w-full">
      <ResponsiveContainer className={"mt-4 -ml-6"} width="110%" height="100%">
        <BarChart
          data={data}
          margin={{ top: 10, right: 10, left: 10, bottom: 10 }}
        >
          <XAxis
            dataKey="date"
            axisLine={false}
            tickLine={false}
            tickMargin={10}
            fontSize={12}
            stroke="#888888"
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tickFormatter={formatYAxis}
            fontSize={12}
            stroke="#888888"
            tickMargin={5}
            // domain={[0, 1000000]}
            // ticks={[0, 200000, 400000, 600000, 800000, 1000000]}
          />
          <Bar
            dataKey="totalAmount"
            fill="#312e81"
            radius={[20, 20, 0, 0]}
            barSize={10}
            className="fill-indigo-950"
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
